module.exports = __webpack_public_path__ + "static/media/energy_weather.9f3fc79c.png";